import MaterialIcons from "@expo/vector-icons/build/MaterialIcons";
import { useNavigation } from "@react-navigation/native";
import { StyleSheet, Text, View } from "react-native";

interface HeaderProps {
  onPressLeftButton?: () => void;
  headerText?: string;
  hasLeftIcon?: boolean;
  hasRightIcon?: boolean;
}

const Header = ({
  onPressLeftButton,
  headerText,
  hasLeftIcon = true,
  hasRightIcon,
}: HeaderProps) => {
  const navigation = useNavigation();

  return (
    <View style={styles.headerContainer}>
      {hasLeftIcon ? (
        <MaterialIcons
          name="chevron-left"
          size={32}
          color="white"
          style={styles.rightIconContainer}
          onPress={() => onPressLeftButton?.() || navigation.goBack()}
        />
      ) : (
        <View style={styles.rightIconContainer} />
      )}
      <Text style={styles.headerText} numberOfLines={1}>
        {headerText || ""}
      </Text>

      {hasRightIcon ? (
        <MaterialIcons
          name="close"
          size={32}
          color="white"
          style={styles.rightIconContainer}
          onPress={() => onPressLeftButton?.() || navigation.goBack()}
        />
      ) : (
        <View style={styles.rightIconContainer} />
      )}
    </View>
  );
};

export default Header;

const styles = StyleSheet.create({
  headerContainer: {
    padding: 12,
    backgroundColor: "transparent",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },

  headerText: {
    color: "white",
    fontSize: 18,
    alignSelf: "center",
    fontWeight: "400",
    fontFamily: "PlusJakartaSans-Regular",
  },

  rightIconContainer: {
    width: 36,
    height: 36,
  },
});
